<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                In Progress Courses
            </p>
        </header>
        <div class="card-body">
            <div class="card-content">
                <table v-if="items">
                    <tr>
                        <td>Course</td>
                        <td>Author</td>
                        <td>RNZCGP CPD</td>
                        <td>Date Started</td>
                    </tr>
                    <tr v-for="item in items" :key="item.id" v-if="!item.pass">
                        <td width="40%">
                            <router-link :to="{name:'score',params:{id:item.id}}"><i class="fas fa-search"></i>
                                {{ item.title }}
                            </router-link>
                        </td>
                        <td width="30%">
                            {{ item.author }}
                        </td>
                        <td width="15%">
                            {{ item.cme }}
                        </td>
                        <td width="20%">
                            {{ item.date }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["items"]

}
</script>
<style scoped>
table {
    width: 100%;
}

table tr {
    height: 40px;
}

.failed {
    background: red;
    color: white;
    padding: 2px 15px 2px 15px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: bold;
}

.passed {
    background: lightgreen;
    color: white;
    padding: 2px 15px 2px 15px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: bold;
}
</style>
